<div class="signup-container">
    <ng-container *ngIf="(device$ | async).isMobile; else desktop">
        <app-smash-navbar-mobile></app-smash-navbar-mobile>
    </ng-container>
    <ng-template #desktop>
        <div class="signup-header">
            <app-smash-header></app-smash-header>
        </div>
    </ng-template>
    <router-outlet class="router"></router-outlet>
</div>